import {call} from 'redux-saga/effects';
import {CommonActions} from '@react-navigation/native';
import type {SignUpActionType} from '../actions';
import Navigation from '../../../lib/navigation';

export function* goToNextEsimPage(
  action: SignUpActionType,
): Generator<*, *, *> {
  if (action.type !== 'SIGNUP_GO_TO_NEXT_ESIM_PAGE') {
    return;
  }

  const navigateTo = (routeName, params) => {
    return CommonActions.navigate({name: routeName, params: params});
  }

  if (action.payload.routeName) {
    return yield call(Navigation.dispatch, navigateTo(action.payload.routeName, action.payload.params ?? {}));
  }

  return yield call(Navigation.dispatch, navigateTo('chooseSimOrEsim', action.payload.params ?? {}),);
}